import { render, staticRenderFns } from "./PatentView.vue?vue&type=template&id=236bc972&scoped=true"
import script from "./PatentView.vue?vue&type=script&setup=true&lang=ts"
export * from "./PatentView.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PatentView.vue?vue&type=style&index=0&id=236bc972&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236bc972",
  null
  
)

export default component.exports